import { memo } from 'react';
import { cn, RawHtml } from '@divlab/divanui';

import H3 from '@Components/H3';
import styles from './ListBlock.module.css';

import type { Installment } from '@Pages/PageCredit/typings';
import type { FC, HTMLAttributes } from 'react';

export interface ListBlockProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  page: Installment;
}

const ListBlock: FC<ListBlockProps> = (props) => {
  const { className, page, ...restProps } = props;

  return (
    <div {...restProps} className={cn(styles.listBlock, className)}>
      <H3 className={styles.title} title={page.title} />

      <ul className={styles.list}>
        {page.list.map((item) => (
          <li className={styles.listItem} key={item}>
            <RawHtml html={item} />
          </li>
        ))}
      </ul>

      {page.note && <div className={styles.nuance}>{page.note}</div>}
    </div>
  );
};

export default memo(ListBlock);
